export const TableItemsNotFound = ({
  message = "There are no items in the list",
}: {
  message?: string;
}) => {
  return <p className="text-gray-600 font-semibold">{message}</p>;
};
